/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseSucResponseDto_Array } from '../models/BaseSucResponseDto_Array';
import type { BaseSucResponseDto_StsResponse } from '../models/BaseSucResponseDto_StsResponse';
import type { FileUploadDto } from '../models/FileUploadDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CosService {
    /**
     * 获取cos的sts
     * 获取cos的sts
     * @returns BaseSucResponseDto_StsResponse 获取COS STS成功
     * @throws ApiError
     */
    public static cosControllerGetDemoSts(): CancelablePromise<BaseSucResponseDto_StsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/cos/sts',
        });
    }
    /**
     * 文件上传
     * 上传文件到COS
     * @param formData 文件上传表单
     * @returns BaseSucResponseDto_Array 文件上传成功
     * @throws ApiError
     */
    public static cosControllerCosUpload(
        formData: FileUploadDto,
    ): CancelablePromise<BaseSucResponseDto_Array> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/cos/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
}
